import isEmpty from 'ramda/src/isEmpty'
import botModule from '@/store/modules/bot.module'
import marketModule from '@/store/modules/market.module'
import marketService from '@/services/amio/market.service'

// Standalone pages (e.g. Variables, Email Template) need bot/market lists for
// selectors and multimarket labels, which are otherwise only loaded on Bots settings.
export async function ensureBotAndMarketLists() {
  try {
    if (isEmpty(botModule.getBotList())) await botModule.setBotList()
    if (isEmpty(marketModule.getMarketList())) {
      marketModule.setMarketList(await marketService.list())
    }
  } catch (err) {
    // non-fatal: selectors degrade to empty or unlabeled lists
  }
}
